module.exports = __webpack_public_path__ + "static/img/phone.ad61778.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/phone.png
// module id = iuBH
// module chunks = 0